import React, { } from 'react'
import {
    Grid,
    Box,
    makeStyles,
    FormHelperText,
    Typography,
    DialogTitle,
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

import {
    StyledTextField,
    StyledFormControl,
    CustomTinyButton,
    CustomDialog,
    CustomButton,
} from '../../common/CustomComponents';
import {
    DEFAULT_WEEKS_PER_YEAR,
    DEFAULT_FORTNIGHTS_PER_YEAR,
    EXACT_WEEKS_PER_YEAR,
    EXACT_FORTNIGHTS_PER_YEAR,
} from '../../../core/calculatorConstants';
import { useCalculator, DISPATCH_UPDATE } from '../../../state/calculatorState';

const useStyles = makeStyles(theme => {
    return {
        root: {
            '& > *': {
                margin: theme.spacing(1),
            },
        },

        image: {
            width: '100%',
            paddingBottom: 20,
        },

        tabs: {
            flexGrow: 1,
            padding: 20,
        },
        tab: {
            padding: 20,
        },
        contentWrapper: {
            paddingTop: 10,
            paddingBottom: 10,
            paddingLeft: 20,
            paddingRight: 20,
        },
        infoText: {
            opacity: 0.5,
            color: theme.palette.primary.contrastText,
            marginLeft: 0,
            marginBottom: -8,
            paddingBottom: 0,
            letterSpacing: "-0.25px",
        },
        infoTextTitle:{
            color: theme.palette.primary.main,
            marginLeft: 0,
            marginBottom: -8,
            paddingBottom: 0,
            letterSpacing: "-0.25px",
        },
        helperText: {
            opacity: 0.5,
            color: theme.palette.primary.contrastText,
            marginLeft: 0,
            marginTop: 4,
            paddingBottom: 4,
            letterSpacing: "-0.25px",
        },
        switchHelperText: {
            opacity: 0.5,
            marginTop: -18,
            paddingLeft: 0,
            marginLeft: 45,
            color: theme.palette.primary.contrastText,
            letterSpacing: "-0.25px",
        },
        insetInput: {
            paddingTop: 2,
            paddingLeft: 45,
        },
        button: {
            paddingLeft: 20,
            paddingRight: 20,
            borderRadius: 2,
            backgroundColor: theme.palette.secondary.light,
            color: theme.palette.grey[100]
        },
        deleteButton: {
            paddingLeft: 10,
            paddingRight: 10,
            // paddingTop:20,
            marginTop: 10,
            width: 40,
            height: 40,
        },
        seperator: {
            height: 1,
            backgroundColor: theme.palette.primary.main,
            opacity: 0.5,
            margin: '5px 0px 0 0',
        }
    }
});

export const AnnualPayCalculation = (props) => {
    const classes = useStyles();
    let [{
        weeksPerYear,
        fortnightsPerYear,
    }, dispatch] = useCalculator();
    const [open, setOpen] = React.useState(false);

    const handleUpdate = (data) => {
        return dispatch({
            type: DISPATCH_UPDATE,
            ...data
        })
    }

    return (
        <Box display="flex" alignItems="flex-end" flexDirection="column" >
            <CustomDialog onClose={() => setOpen(false)} aria-label="Add ongoing costs" open={open} maxWidth="lg" >
                <DialogTitle id="simple-dialog-title" style={{ width: '80%' }} >Edit Annual pay calculation</DialogTitle>
                <Box position="absolute" style={{ width: 20, height: 50, top: 0, right: 44 }}>
                    <CustomButton
                        variant="contained"
                        onClick={() => setOpen(false)}
                    >
                        <CloseIcon style={{ marginTop: 15, marginBottom: 15 }} />
                    </CustomButton>
                </Box>
                <Box style={{ padding: 20, paddingTop: 20 }} >
                    <Grid container spacing={1} >
                        <Grid item xs={12}>
                            <Typography variant="body2">This calculator assumes 52 weeks and 26 fortnights per year, but as weeks do not evenly align with the annual timeframe, it may result in an extra payment. To address this, certain payroll systems opt for an exact division of weeks in a year for precise pay calculations. Utilize this feature to adjust the calculation of weeks and fortnights in a year</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6}>
                            <StyledFormControl variant="filled" fullWidth>
                                <StyledTextField
                                    label="Weeks per year"
                                    fullWidth
                                    value={weeksPerYear}
                                    variant="filled"
                                    type="text"
                                    placeholder=''
                                    onChange={(event) => handleUpdate({ weeksPerYear: Number(event.target.value) })}
                                    id="fnpy"
                                />
                            </StyledFormControl>
                        </Grid>
                        <Grid item xs={6} sm={6}>
                            <StyledFormControl variant="filled" fullWidth>
                                <StyledTextField
                                    label="Fortnights per year"
                                    fullWidth
                                    value={fortnightsPerYear}
                                    variant="filled"
                                    type="text"
                                    placeholder=''
                                    onChange={(event) => handleUpdate({ fortnightsPerYear: Number(event.target.value) })}
                                    id="fnpy"
                                />
                            </StyledFormControl>

                        </Grid>
                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="space-between" alignItems="flex-start" flexDirection="row" style={{ marginBottom: 20, marginTop: 10 }}>
                                <CustomTinyButton
                                    tabIndex="-1"
                                    style={{ display: "block", marginTop: 0, marginRight: 0 }}
                                    variant="contained"
                                    onClick={() => handleUpdate({ weeksPerYear: DEFAULT_WEEKS_PER_YEAR, fortnightsPerYear: DEFAULT_FORTNIGHTS_PER_YEAR })}
                                >
                                    Use Default
                                </CustomTinyButton>
                                <CustomTinyButton
                                    tabIndex="-1"
                                    style={{ display: "block", marginTop: 0, marginRight: 0 }}
                                    variant="contained"
                                    onClick={() => handleUpdate({ weeksPerYear: EXACT_WEEKS_PER_YEAR, fortnightsPerYear: EXACT_FORTNIGHTS_PER_YEAR })}
                                >
                                    Use Exact
                                </CustomTinyButton>
                            </Box>
                        </Grid>
                    </Grid>
                    <Box display="flex" justifyContent="center" >
                        <CustomButton
                            style={{ width: 150 }}
                            variant="contained"
                            onClick={() => setOpen(false)}
                        > DONE
                        </CustomButton>
                    </Box>
                </Box>
            </CustomDialog>
<Box display="flex" alignItems="end" flexDirection="column" style={{paddingRight:10, paddingBottom:10, textAlight:"right"}}>
            <FormHelperText className={classes.infoTextTitle}>{`Annual Pay Calculation`} </FormHelperText>
            <FormHelperText className={classes.infoText}>{`${weeksPerYear} weeks/year ${fortnightsPerYear} fortnights/year`} </FormHelperText>
            
            <CustomTinyButton
                tabIndex="-1"
                style={{ display: "block", marginTop: 10, marginRight: 0}}
                variant="contained"
                onClick={() => setOpen(true)}
            >
                Edit
            </CustomTinyButton>
            </Box>
        </Box>
    )
}

export default AnnualPayCalculation;
